import { create } from 'zustand';

export const useWidgetStore = create((set) => ({
  setData: (id, data) =>
    set(() => ({
      [id]: data,
    })),
}));
